import React from "react";

const Error =()=>{
    return(
        <>
        <h1> Errorr OOps</h1>
        </>
    )
}
export default Error;